import React, { useState, useEffect } from 'react';
import Header from './Header';
import Hero from './Hero';
import About from './About';
import Services from './Services';
import WhyUs from './WhyUs';
import Contact from './Contact';
import Footer from './Footer';
import Impressum from './Impressum';
import Datenschutz from './Datenschutz';
import Objekte from './Objekte';
import CookieBanner from './CookieBanner';

const LandingPage = () => {
  const [currentPage, setCurrentPage] = useState('home');

  // Handle hash changes for navigation
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '');
      if (hash === 'impressum') {
        setCurrentPage('impressum');
      } else if (hash === 'datenschutz') {
        setCurrentPage('datenschutz');
      } else if (hash === 'objekte') {
        setCurrentPage('objekte');
      } else {
        setCurrentPage('home');
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const handleBack = () => {
    window.location.hash = '';
    setCurrentPage('home');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (currentPage === 'impressum') {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <Impressum onBack={handleBack} />
        <Footer />
      </div>
    );
  }

  if (currentPage === 'datenschutz') {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <Datenschutz onBack={handleBack} />
        <Footer />
      </div>
    );
  }

  if (currentPage === 'objekte') {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <Objekte onBack={handleBack} />
        <Footer />
        <CookieBanner />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <WhyUs />
        <Contact />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
};

export default LandingPage;
